import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, composeAuth, AuthError } from "../../helpers/utils";
import { logoutUser } from "./account";

const buildDashboardWidgetsUrl = (payload = {}) => {
  const baseUrl =
    process.env.REACT_APP_SERVER +
    (payload?.isUser
      ? `/api/dashboardWidgets/institution/${payload?.institutionId}/display/me${
          payload?.groupName ? `/${payload.groupName}` : ""
        }`
      : `/api/dashboardWidgets/institution/${payload?.institutionId}/display${
          payload?.groupName ? `/${payload.groupName}` : ""
        }`);

  const query = new URLSearchParams();
  if (Number.isInteger(payload?.limit)) {
    query.set("limit", `${payload.limit}`);
    query.set("offset", `${Number.isInteger(payload?.offset) ? payload.offset : 0}`);
  }

  if (payload.widgetId) query.set("widgetId", payload.widgetId);
  if (Number.isInteger(payload.rowLimit)) query.set("rowLimit", `${payload.rowLimit}`);
  if (Number.isInteger(payload.rowOffset)) query.set("rowOffset", `${payload.rowOffset}`);
  const queryString = query.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const requestDashboardLocationFilters = async ({ jwt, institutionId }, options = {}) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER}/api/locations/institution/${institutionId}?view=dashboard-filters`,
    { headers: { Authorization: composeAuth(jwt) }, signal: options.signal }
  );
  return checkStatus(await response.json())?.data;
};

export const requestDashboardWidgets = async (payload, options = {}) => {
  const url = buildDashboardWidgetsUrl(payload);
  const Authorization = composeAuth(payload?.jwt);

  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      goalids: payload?.goalIds || [],
      locationids: payload?.locationIds || [],
      profileids: payload?.profileIds || [],
    }),
    signal: options?.signal,
  });

  const response = await res.json();
  return checkStatus(response);
};

export const getDashboardWidgets = createAsyncThunk(
  "dashboardWidgets/getDashboardWidgets",
  async (payload, thunkApi) => {
    try {
      return await requestDashboardWidgets(payload);
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
